/** Parsing of the staff dialogs' numeric fields. Pure, so the rules are tested. */

export const QUOTA_MIN = 1
export const QUOTA_MAX = 100_000

export type QuotaInput = { ok: true; value: number | null } | { ok: false }

/** Blank = return that limit to the plan's (null); otherwise a whole number in range. */
export function parseQuota(raw: string): QuotaInput {
  const text = raw.trim()
  if (text === '') return { ok: true, value: null }
  if (!/^\d+$/.test(text)) return { ok: false }
  const n = Number(text)
  return n >= QUOTA_MIN && n <= QUOTA_MAX ? { ok: true, value: n } : { ok: false }
}

/** A positive amount with at most 2 decimals, as the string to send (never rounded). */
export function parseAmount(raw: string): string | null {
  const text = raw.trim()
  if (!/^\d+(\.\d{1,2})?$/.test(text)) return null
  return Number(text) > 0 ? text : null
}
